import { media } from 'src/components/base';
import styled from 'styled-components';
import HorizontalScroll from '..';

/**
 * Styled variant of HorizontalScroll that fits three mini cards (MiniCard) on each "page" of the component.
 */
export const MiniCardHorizontalScroll = styled(HorizontalScroll)`
  li > * {
    ${media.smallUp`
    width: 296px;
  `}

    ${media.mediumUp`
    width: 318px;
  `}
  }
`;
